export default "__VITE_ASSET__BAz0C4_h__"